import { defineStore } from "pinia";
import { ref } from "vue";
import {
  passwordLoginApi,
  codeLoginApi,
  logOutApi,
  phoneMailLoginApi
} from "../apis/login";
import {
  USER_INFO,
  USER_TOKEN
} from "@/config/catch"
import { useLocalStorage } from "@/utils/storage"

export const useUserStore = defineStore("user", () => {
  const userInfo = ref(useLocalStorage.get(USER_INFO));
  const token = ref(useLocalStorage.get(USER_TOKEN));

  const setUserInfo = (data) => {
    userInfo.value = data
    useLocalStorage.set(USER_INFO, data)
  }

  const setUserToken = (data) => {
    token.value = data
    useLocalStorage.set(USER_TOKEN, data)
  }

  const passwordLogin = async (mobile, mail) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await passwordLoginApi(mobile, mail);
        if (response.code === 200) {
          setUserInfo(response.data)
          setUserToken(response.data.token)
          resolve(response)
        } else {
          reject(response.message)
        }
      } catch(err) {
        reject(err.message)
      }
    })
  };
    const phoneMailLogin = async (mail, password) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await phoneMailLoginApi(mail, password);
        if (response.code === 200) {
          setUserInfo(response.data)
          setUserToken(response.data.token)
          resolve(response)
        } else {
          reject(response.message)
        }
      } catch(err) {
        reject(err.message)
      }
    })
  };
  const codeLogin = async (mobile, code) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await codeLoginApi(mobile, code);
        if (response.code === 200) {
          setUserInfo(response.data)
          setUserToken(response.data.token)
          resolve(response)
        } else if (response.code === 205) {
          resolve(response)
        } else{
          reject(response.message)
        }
      } catch(err) {
        reject(err.message)
      }
    })
  };
  const logout = async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await logOutApi()
        if (response.code === 200) {
          userInfo.value = null;
          token.value = null;
         
          useLocalStorage.set(USER_INFO, null)
          useLocalStorage.set(USER_TOKEN, null)
          //  window.location.reload();
          resolve()
        } else {
          reject(response.message)
        }
      } catch(error) {
        reject(error)
      }
    });
  };
  return {
    userInfo,
    token,
    passwordLogin,
    codeLogin,
    logout,
    phoneMailLogin
  };
},{
    persist: true,
});
